function PlatformsGroupItem({ name, icon, to }) {
  return (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      className="text-2xl text-gray-400 hover:text-theme_secondary_sm hover:cursor-pointer transition-all ease-in-out"
    >
      {icon}
    </a>
  );
}

export default PlatformsGroupItem;
